import React from 'react';
import { connect } from "react-redux";
import pdfImg from '../../../../assets/pdf.png';

/**
 *
 * @param {*} param0
 */
const PhotoGrid = ({ photos, onPressImage }) => {
    const styles = {
        container: {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
        },
        image: {
            alignSelf: 'center',
            backgroundColor: 'transparent',
            height: 200,
            width: 'auto',
            marginTop: 10
        }
    };

    return ( 
        <div style={styles.container}>
            {photos.map((photo, i) => {
                const isPDF = photo.file?.type === 'application/pdf' || photo.contentType === 'application/pdf';
                const imageSrc = photo.image || photo.url;

                if (onPressImage) {
                    return (
                        <img
                            key={i}
                            alt="Receipt"
                            src={ isPDF ? pdfImg : imageSrc }
                            style={styles.image}
                            onClick={() => onPressImage(i)}
                        />
                    );
                }

                return (
                    <img key={i} alt="Receipt" src={ isPDF ? pdfImg : imageSrc } style={styles.image} />
                );
            })}
        </div>
    );
};

export default connect()(PhotoGrid);